"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var SavedBlockMoreActionsMenu_1 = require("Dashboard/DashboardBlockLibrary/SavedBlockMoreActionsMenu/SavedBlockMoreActionsMenu");
var BASE_CLASS_NAME = "edit-action-bar";
var EditActionBar = (function (_super) {
    __extends(EditActionBar, _super);
    function EditActionBar() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.renderSaveChangeButton = function () {
            var editActionBarStore = _this.props.editActionBarStore;
            var isButtonDisabled = !editActionBarStore.isSavingChanges && !editActionBarStore.hasUnsavedChanges;
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { show: isButtonDisabled ? undefined : false, wrapTarget: true, size: kaleidoscope_1.TooltipSize.Large, content: "All changes saved" },
                react_1.default.createElement(kaleidoscope_1.Button, { className: "".concat(BASE_CLASS_NAME, "__save-changes"), type: kaleidoscope_1.ButtonType.Primary, disabled: isButtonDisabled, onClick: _this.onSaveClickHandle, successMessage: "Saved" }, editActionBarStore.isNewSavedBlock ? "Save block" : "Save changes")));
        };
        _this.onSaveClickHandle = function (event) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.editActionBarStore.saveChanges()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.onToggleEditingIsLockedToAdmins = function () { return __awaiter(_this, void 0, Promise, function () {
            var editActionBarStore, newState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        editActionBarStore = this.props.editActionBarStore;
                        newState = !editActionBarStore.isEditingIsLockedToAdmins;
                        return [4, editActionBarStore.setLockEditingSetting(newState)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        return _this;
    }
    EditActionBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, userIsAdmin = _a.userIsAdmin, editActionBarStore = _a.editActionBarStore, onCloseClick = _a.onCloseClick;
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__block-name") },
                react_1.default.createElement(kaleidoscope_1.TextInput, { variant: kaleidoscope_1.TextInputVariant.Underlined, label: "Saved Block Name", placeholder: "Saved Block Name", labelHidden: true, endElement: react_1.default.createElement(icons_1.Edit, null), onChange: editActionBarStore.onBlockNameChange, onBlur: editActionBarStore.onBlockNameInputBlur, value: editActionBarStore.blockName })),
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__actions") },
                this.renderSaveChangeButton(),
                react_1.default.createElement(SavedBlockMoreActionsMenu_1.SavedBlockMoreActionsMenu, { userIsAdmin: userIsAdmin, editingIsLockedToAdmins: editActionBarStore.isEditingIsLockedToAdmins, blockId: editActionBarStore.blockId, onToggleEditingIsLockedToAdmins: function () {
                        _this.onToggleEditingIsLockedToAdmins();
                    }, hideCopyBlockIdOption: editActionBarStore.isNewSavedBlock, onDeleteClick: editActionBarStore.delete, className: "".concat(BASE_CLASS_NAME, "__more-actions") }),
                react_1.default.createElement(kaleidoscope_1.IconButton, { className: "".concat(BASE_CLASS_NAME, "__close"), type: kaleidoscope_1.ButtonType.Tertiary, onClick: onCloseClick, buttonState: kaleidoscope_1.ButtonState.Idle, icon: react_1.default.createElement(icons_1.Close, null) }))));
    };
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EditActionBar.prototype, "onSaveClickHandle", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EditActionBar.prototype, "onToggleEditingIsLockedToAdmins", void 0);
    EditActionBar = __decorate([
        mobx_react_1.observer
    ], EditActionBar);
    return EditActionBar;
}(react_1.default.Component));
exports.default = EditActionBar;
